export default function EmptyState({
  title,
  description,
  actionLabel,
  onAction,
}: {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-14 text-center animate-fade-in">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-background-200 text-foreground-500">
        <i className="ri-search-eye-line text-2xl"></i>
      </span>
      <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{title}</h3>
      <p className="mt-2 max-w-md text-sm text-foreground-600">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-5 flex h-10 items-center gap-2 rounded-md bg-primary-500 px-4 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
        >
          <span className="flex h-4 w-4 items-center justify-center">
            <i className="ri-refresh-line"></i>
          </span>
          {actionLabel}
        </button>
      )}
    </div>
  );
}